<div>
  <span><strong>{{docTotal}}</strong>{{ 'lf_fileset_num_documents' | localize: lfFilesetLocalizeHelper }}</span>
  <div class="docorg-toolbar" [ngClass]="{'readonly': isReadonly, 'disabled': isDisabled}" *ngIf="!isReadonly">

    <button type="button" icon-button (click)="onRefreshClick()" title="{{ 'lf_fileset_refresh' | localize: lfFilesetLocalizeHelper }}">
      <svg class="tool-bar-icon">
          <use xlink:href="#_svg-refresh"></use>
      </svg>
    </button>

    <button [disabled]="!numSelectedDocs() > 0" [hidden]="types.length == 0" type="button" icon-button (click)="onTypeChangeClick()" title="{{ 'lf_fileset_change_doc_type_pl' | localize: lfFilesetLocalizeHelper }}" cdkOverlayOrigin #trigger="cdkOverlayOrigin">
      <svg class="tool-bar-icon" style="height:20px; width:20px; transform: translate(0, -2px);">
          <use xlink:href="#_svg-type-icon"></use>
      </svg>
    </button>

    <button [disabled]="numSelectedDocs() != 1" type="button" icon-button *ngIf="allowDownload" (click)="onDownloadClick()" title="{{ 'lf_fileset_download_file' | localize: lfFilesetLocalizeHelper }}">
      <svg class="tool-bar-icon">
        <use xlink:href="#_svg-file-download"></use>
      </svg>
    </button>

    <button type="button" icon-button *ngIf="importMode > 0 && types.length == 0" (click)="onImportClick()" title="{{ 'lf_fileset_import' | localize: lfFilesetLocalizeHelper }}">
      <svg class="tool-bar-icon">
          <use xlink:href="#_svg-file-upload"></use>
      </svg>
    </button>
    
    <button [disabled]="!numSelectedDocs() > 0" type="button" icon-button (click)="onDeleteClick()" title="{{ 'lf_fileset_remove' | localize: lfFilesetLocalizeHelper }}">
      <svg class="tool-bar-icon">
          <use xlink:href="#_svg-delete"></use>
      </svg>
    </button>

    <ng-template
      cdkConnectedOverlay
      [cdkConnectedOverlayOrigin]="trigger"
      [cdkConnectedOverlayOpen]="isChangeTypeOpen"
      [cdkConnectedOverlayOffsetY]="2"
      (overlayOutsideClick)="isChangeTypeOpen = false"
    >
      <div class="type-change-container">
        <div><strong>{{ 'lf_fileset_change_doc_type' | localize: lfFilesetLocalizeHelper }}</strong></div>
        <div>
          <ul class="type-change-ul-list">
            <li *ngFor="let type of types">
              <input type="radio"
                    [attr.id]="'changedToTypeRadios' + type.key"
                    name="changedToTypeRadios"
                    [value]="type.key"
                    [(ngModel)]="toType"/>
              <label [attr.for]="'changedToTypeRadios' + type.key" >{{type.display}}</label>
            </li>
          </ul>
        </div>
          
        <div>
          <button type="button" (click)="typeChange.emit(toType); isChangeTypeOpen=false">{{ 'lf_fileset_change' | localize: lfFilesetLocalizeHelper }}</button>
        </div>
      </div>
    </ng-template>
  </div>
</div>


